import { render, staticRenderFns } from "./declareList - 20220428改动前.vue?vue&type=template&id=37073fe9&scoped=true"
import script from "./declareList - 20220428改动前.vue?vue&type=script&lang=js"
export * from "./declareList - 20220428改动前.vue?vue&type=script&lang=js"
import style0 from "./declareList - 20220428改动前.vue?vue&type=style&index=0&id=37073fe9&lang=less"
import style1 from "./declareList - 20220428改动前.vue?vue&type=style&index=1&id=37073fe9&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37073fe9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37073fe9')) {
      api.createRecord('37073fe9', component.options)
    } else {
      api.reload('37073fe9', component.options)
    }
    module.hot.accept("./declareList - 20220428改动前.vue?vue&type=template&id=37073fe9&scoped=true", function () {
      api.rerender('37073fe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/declareList - 20220428改动前.vue"
export default component.exports